/**
 * GPS yardımcı fonksiyonları.
 * Haversine formülü ile iki nokta arası mesafe (metre).
 */

/** Şube GPS doğrulaması için varsayılan yarıçap (metre). */
export const GPS_DOGRULAMA_YARICAPI_METRE = 50

export interface GpsKonumu {
  lat: number
  lng: number
  accuracy?: number
}

/**
 * İki GPS noktası arası mesafeyi metre cinsinden döndürür.
 * Haversine formülü.
 */
export function mesafeMetre(a: GpsKonumu, b: GpsKonumu): number {
  const R = 6371e3 // Dünya yarıçapı (metre)
  const phi1 = (a.lat * Math.PI) / 180
  const phi2 = (b.lat * Math.PI) / 180
  const deltaPhi = ((b.lat - a.lat) * Math.PI) / 180
  const deltaLambda = ((b.lng - a.lng) * Math.PI) / 180

  const x =
    Math.sin(deltaPhi / 2) ** 2 +
    Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2

  const c = 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x))
  return R * c
}

/**
 * 50 metre yarıçap kuralı kontrolü.
 */
export function yaricapIcindeMi(
  konum: GpsKonumu,
  hedef: GpsKonumu,
  yaricap: number = GPS_DOGRULAMA_YARICAPI_METRE
): boolean {
  return mesafeMetre(konum, hedef) <= yaricap
}

/**
 * Mevcut konumu al.
 * Promise döndürür — kullanıcı izin vermezse veya GPS yoksa hata fırlatır.
 */
export function suAnkiKonum(): Promise<GpsKonumu> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Tarayıcın konum servisini desteklemiyor.'))
      return
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        })
      },
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          reject(new Error('Konum erişim izni reddedildi. Telefon ayarlarından ver.'))
        } else if (err.code === err.POSITION_UNAVAILABLE) {
          reject(new Error('Konum alınamadı. GPS açık mı?'))
        } else if (err.code === err.TIMEOUT) {
          reject(new Error('Konum zaman aşımı. Tekrar dene.'))
        } else {
          reject(new Error('Konum hatası: ' + err.message))
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 30000,
      }
    )
  })
}
